import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateFaAdditionsPdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  assetLines,
  otherSources,
  registeredAssetSources,
  totalLines,
  totalAdditions,
  otherSourcesTotalLines,
  registeredAssetSourcesTotalLines,
  combinedTotalLines,
  filteredUsedColumns,
  caSettings,
  refSources,
  notes,
  reviewNotes,
  renovationScheduleNo,
}) => {
  const sharedArgs = [
    schedule,
    company,
    assetLines,
    otherSources,
    registeredAssetSources,
    totalLines,
    totalAdditions,
    otherSourcesTotalLines,
    registeredAssetSourcesTotalLines,
    combinedTotalLines,
    filteredUsedColumns,
    caSettings,
    refSources,
    notes,
    reviewNotes,
    renovationScheduleNo,
  ];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) =>
          generateFaAdditionsPdf(forView, ...sharedArgs)
        }
        downloadName='Fixed Additions'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFaAdditionsPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
